import axios from "axios";
import { React, useState, useRef, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { API_BASE_URL } from "../../environment";
import NewTopNavBar from "../NewTopNavBar";
import { useNavigate } from "react-router-dom";
import BackImg from "../../Img/back.png";
import { toast } from "react-toastify";
import AllPostsLike from "./AllPostsLike";

const ShowSubCategoryNew = () => {
  const [spinnerLoading, setSpinnerLoading] = useState(true);
  const [filterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false); // To indicate loading for infinite scroll
  const [page, setPage] = useState(1); // Start from page 1
  const sentinelRef = useRef(null);
  const [query, setQuery] = useState("");
  const [postTitles, setPostTitles] = useState([]);
  const navigate = useNavigate();
  const [isDisplay, setIsDisplay] = useState(true);
  const [collaps, setCollaps] = useState(true);
  const [hasMore, setHasMore] = useState(true); // To track if more data is available
  const [articleData, setArticleData] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [spnierLoading, setSpnierLoading] = useState(true);
  const [pageloading, setPageLoading] = useState(true);
  const [articleLoading, setArticleLoading] = useState(true);
  const per_page = 6;
  let bearerToken = localStorage.getItem("jwt_token");

  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };

  const fetchPostTitles = () => {
    if (query) {
      fetch(
        `${API_BASE_URL}/wp-json/wp/v2/posts?search=${query}&categories=${localStorage.getItem(
          "catagoryId"
        )}&per_page=100`,
        config
      )
        .then((response) => response.json())
        .then((data) => {
          setPostTitles(data);
          setIsDisplay(true);
        })
        .catch((error) => {
          console.error(error);
          localStorage.removeItem("jwt_token");
          navigate("/");
        });
    } else {
      setPostTitles([]);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (query.trim() !== "") {
        fetchPostTitles();
      } else {
        setPostTitles([]);
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [query]);

  const getAllSubCategory = (page) => {
    setLoading(true); // Start loading
    axios
      .get(
        `${API_BASE_URL}/wp-json/category-api/v1/get-subcategories/?category_id=${localStorage.getItem(
          "catagoryId"
        )}&page=${page}`,
        config
      )
      .then((res) => {
        if (res.data.length > 0) {
          setFilterData((prevData) => [...prevData, ...res.data]);
          setHasMore(res.data.length > 0); // Check if more data is available
          // setArticleLoading(false)
          setSpnierLoading(false)
        } else {
          //
          if (res.data.length == 0 && page == 1) {
            axios
              .get(
                `${API_BASE_URL}/wp-json/wp/v2/posts?per_page=${per_page}&page=${page}&categories=${localStorage.getItem(
                  "catagoryId"
                )}`,
                config
              )
              .then((res) => {
                if (res.data.length > 0) {
                  setAllCategory(res.data);
                  setFilterData((prevPosts) => [...prevPosts, ...res.data]);
                  setHasMore(res.data.length > 0);
                  // setSpnierLoading(true);

                  // setLoading(true);
                } else {
                  setHasMore(false);
                  setSpnierLoading(false);
                  // setLoading(false);
                  setPageLoading(false);
                }
                setArticleLoading(false);
              })
              .catch((err) => {
                console.log(err);
                setLoading(false);
              })
              .finally(() => {
                setSpnierLoading(false);
              });
          }
          // 
          setHasMore(false); // No more data available
        }
        //
        // if (page == 1 && res.data.length == 0) {
        //   axios
        //     .get(
        //       `${API_BASE_URL}/wp-json/wp/v2/posts?per_page=${per_page}&page=${page}&categories=${localStorage.getItem(
        //         "catagoryId"
        //       )}`,
        //       config
        //     )
        //     .then((res) => {
        //       if (res.data.length > 0) {
        //         setAllCategory(res.data);
        //         setFilterData((prevPosts) => [...prevPosts, ...res.data]);
        //         setHasMore(res.data.length > 0);
        //         // setSpnierLoading(true);

        //         // setLoading(true);
        //       } else {
        //         setHasMore(false);
        //         setSpnierLoading(false);
        //         // setLoading(false);
        //         setPageLoading(false);
        //       }
        //       setArticleLoading(false);
        //     })
        //     .catch((err) => {
        //       console.log(err);
        //       setLoading(false);
        //     })
        //     .finally(() => {
        //       setSpnierLoading(false);
        //     });
        // }

        //
        setLoading(false); // Stop loading
        setSpinnerLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };
  // Initial useEffect to load data when the component is mounted (initial load)
  useEffect(() => {
    getAllSubCategory(1); // Load the first page initially
  }, []); // Empty dependency array ensures this runs once on mount
  useEffect(() => {
    if (page > 1) {
      getAllSubCategory(page);
    }
  }, [page]);

  // Use IntersectionObserver for infinite scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !loading) {
          setPage((prevPage) => prevPage + 1); // Load next page
        }
      },
      { threshold: 1 }
    );

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }

    return () => {
      if (sentinelRef.current) {
        observer.unobserve(sentinelRef.current);
      }
    };
  }, [loading, hasMore]);

  const goBack = () => {
    navigate("/default-page");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (query === "") {
      toast.error("Enter text to perform a search.");
      return;
    } else if (query.length === 1) {
      toast.error("Please provide additional text to refine your search.");
      return;
    }
    navigate(`/results`);
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };

  const goToArticlePage = (postId) => {
    localStorage.setItem("postId", postId);
    navigate(`/single-article?id=${postId}`);
  };

  const categoryHandle = (catId, subcatName) => {
    localStorage.setItem("subcategoryId", catId);
    navigate("/category-posts");
    localStorage.setItem("subcategoryName", subcatName);
  };
  localStorage.setItem("searchQuery", query);
  const gotToArticlePage = (postId) => {
    localStorage.setItem("postId", postId);
    navigate(`/single-article?id=${postId}`);
  };
  return (
    <div>
      <NewTopNavBar />
      <div className="w-100 position-relative">
        <div className="w-100 pt-5 fw-bold">
          <div className="ps-4 ms-3">
            <img
              className="commonLogo"
              style={{ cursor: "pointer" }}
              onClick={goBack}
              src={BackImg}
              alt="Back"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back"
            />
          </div>

          <div className="d-flex flex-column justify-content-center">
            <p style={{ fontSize: "28px" }}>Search for Articles</p>
          </div>

          <div className="search-back w-100">
            <form className="search-form mb-5" onSubmit={handleSearch}>
              <label style={{ flex: "1", background: "#ffffff59" }}>
                <input
                  type="text"
                  className="search-field"
                  placeholder="Search..."
                  value={query}
                  onChange={handleInputChange}
                />
              </label>
              <button type="submit" className="search-submit">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z"
                  ></path>
                </svg>
              </button>
            </form>
          </div>
        </div>

        {query.trim() !== "" && (
          <ul className={collaps ? "suggestion-list2" : "suggestion-list"}>
            {postTitles.map((title, index) => (
              <li
                key={index}
                className="suggestion"
                onClick={() => goToArticlePage(title.id)}
              >
                {title.title.rendered}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div id="subcategory-main-div" className="overflow-auto">
        <div className="pt-4">
          {spinnerLoading ? (
            <div className="d-flex justify-content-center w-100">
              <Spinner />
            </div>
          ) : filterData.length > 0 && articleLoading ? (
            <div className="container">
              <div className="row">
                <div>
                  <h2 className="fw-bold pb-2 text-center">
                    {localStorage.getItem("categoryName")}
                  </h2>
                  <h4 className="fw-bold pb-2 text-center">Sub-Category </h4>
                </div>

                {filterData.map((val) => (
                  <div
                    key={val.id}
                    onClick={() => categoryHandle(val.id, val.name)}
                    className="col-sm-6 col-md-6 col-lg-4"
                  >
                    <div className="d-flex border m-2 mt-0 categoryBoxMainDiv">
                      <div className="ps-3">
                        <div className="categoryNameDiv">
                          <p className="mb-0 fw-bold">
                            {val.name.length > 30
                              ? `${val.name.slice(0, 30)}...`
                              : val.name}
                          </p>
                        </div>
                        <div className="d-flex">
                          <p className="mb-0">
                            {val.unique_authors_count}{" "}
                            {val.unique_authors_count <= 1
                              ? "Author"
                              : "Authors"}
                          </p>
                          <p className="ps-4 mb-0">
                            {val.post_count}{" "}
                            {val.post_count <= 1 ? "Article" : "Articles"}{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Sentinel div for infinite scroll */}
              <div
                ref={sentinelRef}
                className="sentinel"
                style={{ height: "50px" }}
              >
                {loading && (
                  <div className="d-flex justify-content-center w-100">
                    <Spinner />
                  </div>
                )}
              </div>
            </div>
          ) :
            filterData.length > 0 && articleLoading === false ? (
              <>
                {/* Display the category name */}
                {localStorage.getItem("categoryName") && (
                  <div className="text-center mb-4">
                    <h2 className="fw-bold">
                      {localStorage.getItem("categoryName")}
                    </h2>
                  </div>
                )}

                {/* Map through filterData */}
                {filterData?.map((val) => {
                  return (
                    <div className="container" key={val.id}>
                      <div className="row">
                        <div className="col-12">
                          <div
                            style={{ cursor: "pointer" }}
                            className=""
                            onClick={() => gotToArticlePage(val.id)}
                          >
                            <div className="">
                              <h5
                                style={{
                                  color: "#092360",
                                  height: "auto",
                                }}
                                className="elepse-post-heading m-0 fw-bold mb-1"
                              >
                                {val?.title?.rendered
                                  ? val.title.rendered.length > 100
                                    ? val.title.rendered.slice(0, 100) + "..."
                                    : val.title.rendered
                                  : ""}
                              </h5>
                              <AllPostsLike postId={val.id} />

                              <p
                                className="p-0 m-0 fw-bold"
                                dangerouslySetInnerHTML={{
                                  __html: val?.excerpt?.rendered
                                    ? val.excerpt.rendered.length > 300
                                      ? val.excerpt.rendered.slice(0, 300) + "..."
                                      : val.excerpt.rendered
                                    : "",
                                }}
                              ></p>
                              <div className="post-me">
                                <div></div>
                              </div>
                            </div>
                          </div>
                          <hr />
                        </div>
                      </div>
                    </div>
                  );
                })}
                {/* Sentinel div for infinite scroll */}
                <div
                  ref={sentinelRef}
                  className="sentinel"
                  style={{ height: "50px" }}
                >
                  {loading && (
                    <div className="d-flex justify-content-center w-100">
                      <Spinner />
                    </div>
                  )}
                </div>

              </>

            ) : spinnerLoading ? (
              <div className="text-center w-100 my-5">
                <h5>No Article found</h5>
              </div>
            ) : ""}
        </div>
      </div>
    </div >
  );
};

export default ShowSubCategoryNew;
